import styled from '@emotion/styled';
import { APP_IMG } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import Image from './image';
// { isLoading, language, isTranslate, handleTranslate, eventDataLayer }

const WidgetTranslate = ({ selectLang, handleTranslate, eventDataLayer }) => {
  const langList = [
    { id: 'TH', name: 'TH', image: '/images/translates/TH.png' },
    { id: 'EN', name: 'EN', image: '/images/translates/EN.png' },
    { id: 'CN', name: 'CN', image: '/images/translates/CN.png' }
  ];
  // const [selectLang, setSelectLang] = useState('EN');
  const handleClickItem = item => {
    // setSelectLang(item.name);
    handleTranslate(item.id);
  };

  return (
    <WidgetWrapper className='item-wrapper'>
      {langList.map((item, index) => (
        <div
          className={`lang-item ${selectLang === item.id ? 'selected' : 'unselected'}`}
          key={index}
          onClick={() => {
            handleClickItem(item);
            // ! DATALAYER
            sendDataLayerGlobal({
              ...eventDataLayer,
              data: {
                ...eventDataLayer.data,
                title: item.name,
                index: index + 1
              }
            });
          }}
        >
          <Image external image={`${APP_IMG}${item.image}`} alt={item.id} title={item.id} />
          {/* <div className='text'>{item.name}</div> */}
        </div>
      ))}
    </WidgetWrapper>
  );
};
const WidgetWrapper = styled.div`
  position: relative;
  width: fit-content;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: nowrap;
  padding: 5px 0;
  width: 30%;
  overflow: auto;
  ::-webkit-scrollbar {
    height: 4px;
    /* width: 3px; */

    background-color: #f5f5f58a;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 5px grey; */
    border-radius: 10px;
    background-color: #f5f5f58a;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #00aa2c;
    border-radius: 10px;
  }
  /* @media (min-width: 1025px) {
    width: 5%;
  } */
  @media (max-width: 768px) {
    width: 20%;
    overflow: auto;
  }
  /* @media (max-width: 690px) {
    width: 40%;
  } */
  @media (max-width: 380px) {
    width: 17%;
  }
  .selected {
    img {
      border: 2px solid #000;
    }
  }
  .unselected {
    opacity: 0.5;
  }
  .lang-item {
    padding: 0 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    @media (max-width: 767px) {
      padding: 0 3px;
    }
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      @media (max-width: 690px) {
        width: 35px;
        height: 35px;
      }
      @media (max-width: 475px) {
        width: 30px;
        height: 30px;
      }
    }
    .text {
      font-size: 0.65rem;
      padding-top: 4px;
    }
    &:hover {
      /* background-color: rgba(31, 41, 154, 0.1); */
      opacity: 0.8;
    }
  }
`;
export default WidgetTranslate;
